import { Injectable } from '@angular/core';

@Injectable()
export class PageDefault {

    public static PageIndex() {
        return 1;
    }

    public static PageSize() {
        return 30;
    }

    public static startDate() {
        let date = new Date();
        var month = date.getMonth() + 1;
        var m = "";
        if (month >= 1 && month <= 9) {
            m = "0" + month;
        } else {
            m = "" + month;
        }

        return date.getFullYear() + "-" + m + "-01";
    }

    public static endNowDate() {
        let date = new Date();
        var month = date.getMonth() + 1;
        var m = "";
        var d = "";
        var strDate = date.getDate(); 
        if (month >= 1 && month <= 9) {
            m = "0" + month;
        } else {
            m = month + "";
        }
        if (strDate >= 0 && strDate <= 9) {
            d = "0" + strDate;
        } else {
            d = "" + strDate;
        }
        return date.getFullYear() + "-" + m + "-" + d;
    }

    public static endDate() {
        let date = new Date();
        date.setDate(date.getDate()+1);
        var month = date.getMonth() + 1;
        var m = "";
        var d = "";
        var strDate = date.getDate(); 
        if (month >= 1 && month <= 9) {
            m = "0" + month;
        } else {
            m = month + "";
        }
        if (strDate >= 0 && strDate <= 9) {
            d = "0" + strDate;
        } else {
            d = "" + strDate;
        }
        return date.getFullYear() + "-" + m + "-" + d;
    }

    // 格式化时间
    static formatTime(seconds) {
        var s = 1, m = 60 * s, h = m * 60;
        var ss = 0, mm = 0, hh = 0;
        if (s > 0) {
            hh = Math.floor(seconds / h);
            mm = Math.floor(seconds % h / m);
            ss = Math.floor(seconds % h % m / s);
        }
        var p = function (t) {
            return t < 10 ? '0' + t : t;
        }
        return [p(hh), p(mm), p(ss)];
    }

}


// WEBPACK FOOTER //
// ./src/pages/PageDefault.ts